module.exports = __webpack_public_path__ + "static/media/government.6d15aae7.jpg";